import { call, put, select, cancelled, takeEvery } from 'redux-saga/effects'
import { selectUser } from './user'

import axios from 'axios'
import { get } from 'lodash-es'
import API from '../config'
import { getHeaders } from './api'
// ------------------------------------
// Constants
// ------------------------------------
const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const REQUEST_SETTINGS = 'REQUEST_SETTINGS'
export const RECEIVE_SETTINGS = 'RECEIVE_SETTINGS'
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'

// ------------------------------------
// Actions
// ------------------------------------
export function requestSettings() {
  return { type: REQUEST_SETTINGS }
}

function receiveSettings(payload) {
  return {
    type: RECEIVE_SETTINGS,
    payload
  }
}

export function updateSettings(payload) {
  return { type: UPDATE_SETTINGS, payload }
}

function* getSettings() {
  const url = `${rootApi}account/get-read-settings`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  if (token) {
    try {
      const response = yield call([axios, 'get'], url, {
        params: {},
        headers: getHeaders(token),
        cancelToken: source.token
      })
      yield put(receiveSettings(response.data.settings))
    } catch (err) {
    } finally {
      if (yield cancelled()) {
        source.cancel()
      }
    }
  }
}

function* saveSettings(action) {
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  // eslint-disable-next-line camelcase
  const { theme, fontSize: font_size, lineHeight: line_height, fontFamily: font, voice, rate, volume } = action.payload
  if (token) {
    const response = yield call(
      [axios, 'post'],
      'account/update-read-settings',
      {
        theme,
        font_size,
        line_height,
        font: font,
        voice,
        rate,
        volume
      },
      {
        baseURL: `${API.apiPath}/${API.apiVersion}/`,
        headers: getHeaders(token)
      }
    )
    yield put(receiveSettings(response.data.settings))
  } else {
    yield put(receiveSettings({ theme, font_size, line_height, font, voice, rate, volume }))
  }
}

export function* readSettingsSaga() {
  yield takeEvery(REQUEST_SETTINGS, getSettings)
}

export function* updateReadSettingsSaga() {
  yield takeEvery(UPDATE_SETTINGS, saveSettings)
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  theme: 'white',
  fontSize: 17,
  lineHeight: 1.15,
  fontFamily: 'Circular Std',
  volume: 1,
  rate: 1,
  voice: 0
}

export default function(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_SETTINGS: {
      const {
        theme,
        font_size: fontSize,
        line_height: lineHeight,
        font: fontFamily,
        volume,
        rate,
        voice
      } = action.payload
      return {
        theme: theme || state.theme,
        fontSize: fontSize || state.fontSize,
        lineHeight: lineHeight || state.lineHeight,
        fontFamily: fontFamily || state.fontFamily,
        volume: typeof volume === 'number' ? volume : state.volume,
        rate: rate || state.rate,
        voice: typeof voice === 'number' ? voice : state.voice
      }
    }
  }
  return state
}
